import moment from 'moment';
import { createSelector } from 'reselect';
import _ from 'lodash';

export const selectConference = ({ conference }) => conference;
export const selectConferenceId = (state) => selectConference(state).id;
export const selectCallAudio = (state) => selectConference(state).callAudio;
export const conferenceExpandedId = (state) => selectConference(state).expandedId;
export const selectOrganizationId = (state) =>
  selectConference(state).organizationId
    ? String(selectConference(state).organizationId)
    : '-';
export const selectTranscriptId = (state) => selectConference(state).transcriptId;
export const selectPeople = (state) => {
  return selectConference(state).people.filter(({ organizationId }) => !organizationId);
};
export const selectSpeakersFromTranscript = (state) =>
  selectConference(state).peopleForDiscussionPoints;
export const selectWatermark = (state) => selectConference(state).watermark;
export const selectWatermarkForAttendee = createSelector(
  selectConference,
  ({ watermarkData }) => {
    if (!watermarkData || typeof watermarkData !== 'object') return undefined;
    const { name, email: emailAddress } = watermarkData;
    return { name, emailAddress };
  },
);
export const selectRequestedTranscriptId = (state) =>
  selectConference(state).requestedTranscriptId;

// Moment selectors:
const selectMoment = (state) => moment.parseZone(selectConference(state).date);

export const selectDateOnly = (state) => selectMoment(state).format('MM/DD/YYYY');

export const selectHours = (state) => selectMoment(state).format('HH');

export const selectMinutes = (state) => selectMoment(state).format('mm');

export const selectTimezone = (state) => selectMoment(state).format('Z');

export const selectIntroMessageId = (state) =>
  selectConference(state).introMessageId
    ? String(selectConference(state).introMessageId)
    : null;

export const selectCurrentOrganization = ({
  organizations: {
    list: { data: organizationList = [] },
  },
  conference,
}) => {
  return organizationList.find(
    ({ id }) => String(id) === String(conference.organizationId),
  );
};

export const selectDefaultAttendees = (state) => {
  const organization = selectCurrentOrganization(state);
  const attendees = _.get(organization, 'attendees', []);
  return attendees.map((attendee) => ({ ...attendee, readOnly: true }));
};

export const selectRecordings = (state) => selectConference(state).recordings;

export const selectCurrentTranscriptId = (state) => {
  const recordings = selectRecordings(state);
  return _.get(recordings, '[0].transcriptEntryId');
};

export const selectTranscriptIdsFromRecordings = (state) =>
  _.uniq(_.map(selectRecordings(state), 'transcriptEntryId'));



// WEBPACK FOOTER //
// ./redux/selectors/conference.js